import React, {PureComponent, ReactNode} from "react"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {Para} from "@irati/ui/src/Labels"

const RightAlign = styled(Para)`
  text-align: right;
`

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  padding-bottom: 5px;
  ${({isLast}) => (isLast || `border-bottom: 1px solid ${greys.light};`)};
`

const StyledPending = styled.span`
  display: block;
  padding-top: 5px;
  color: ${greys.mediumLight};
`

interface Props {
  leftText: string | ReactNode,
  rightText: string | ReactNode,
  pending?: ReactNode,
  isLast?: boolean
}

class Row extends PureComponent<Props> {
  static defaultProps = {
    isLast: false,
    pending: undefined
  }
  render() {
    const {leftText, rightText, pending, isLast} = this.props
    return (
      <StyledRow isLast={isLast}>
        <Para> {leftText} </Para>
        <RightAlign> {rightText}
          {pending && <StyledPending>pending {pending}</StyledPending>}
        </RightAlign>
      </StyledRow>
    )
  }
}

export default Row
